// 如果正式上线 需要修改

const prod = {
  www: "https://www.metal.com",
  user: "https://user.metal.com",
  buy: "https://buy.metal.com",
  news: "https://news.metal.com",
  reports: "https://reports.metal.com",
  ai: "https://ai.metal.com",
  car: "https://car.metal.com",
}

type SiteKey = keyof typeof prod

const test: Record<SiteKey, string> = {
  www: "https://testwww.metal.com",
  user: "https://testuser.metal.com",
  buy: "https://testbuy.metal.com",
  news: "https://testnews.metal.com",
  reports: "https://testreports.metal.com",
  ai: "https://testai.metal.com",
  car: "https://testcar.metal.com",
}

/**
 * 判断是否是生产环境
 */
export const isProduction = process.env.NEXT_PUBLIC_ENV === "production"

export const getUrlByEnv = (key: SiteKey) => {
  return isProduction ? prod[key] : test[key]
}

/**
 * 获取站点url
 *
 * @param key 单/多个站点key
 *
 * @example
 * ```
 * getSiteUrl('www') => https://www.metal.com
 * getSiteUrl(['www', 'user']) => { www: 'https://www.metal.com', user: 'https://user.metal.com' }
 * ```
 */
export function getSiteUrl(key: SiteKey): string
export function getSiteUrl(keys: SiteKey[]): Record<SiteKey, string>
export function getSiteUrl(keys: SiteKey | SiteKey[]): string | Record<SiteKey, string> {
  if (Array.isArray(keys)) {
    return keys.reduce(
      (acc, key) => {
        acc[key] = getUrlByEnv(key)
        return acc
      },
      {} as Record<SiteKey, string>
    )
  } else {
    return getUrlByEnv(keys)
  }
}
